import { IComponentOptions } from "angular";
import { LookupDetailController } from "./controller";

export const vsComponentName = "lookupDetails";

export const lookupDetailComponentOptions: IComponentOptions = {
  controller: LookupDetailController,
  controllerAs: "componentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    lookUpID: "<",
    lookupItem: "<",
    lookupReferences: "<",
    editPermission: "<",
    lookupManagementConfig: "<",
    lookupType: "<",
  },
};
